import { Badge } from "@cloudscape-design/components-themed";
import { useCodelistHook } from "../../app/useCodelistHook";
import { getDivisionLabel } from "../default-constants";

interface ICategoryBadge {
  categoryCode: string;
}

export const CategoryBadge = ({ categoryCode }: ICategoryBadge) => {
  const { announcementCategory } = useCodelistHook();
  return (
    <Badge color={"blue"}>
      {getDivisionLabel(announcementCategory, categoryCode)}
    </Badge>
  );
};
